/*
  Design Tiles – freight quoted separately (cart drawer + cart page + checkout pop-up).

  Some items have no freight price at checkout and are quoted after the order:
    • every Vanity (own shipping profile, $0 "Vanity freight TBA")
    • table-freight items (Tiles, Basins, Toilets, Timber Flooring) when their combined weight
      is over 3,000 kg (Design Tiles Freight returns "Tile freight TBA").
  Shopify merges shipping from different profiles into one "Shipping" line, which hides that.
  So this script:
    1. adds a visible line-item property ("⚠️ Freight: Quoted separately – …") to those lines,
       shown in the cart, in Shopify checkout under the product, and on the order;
    2. shows a notice above the Checkout button in the drawer and on the cart page;
    3. shows a pop-up every time Checkout is clicked while the cart has quoted items.
  Remove the include lines in layout/theme.liquid to switch it all off.
*/
(function () {
  var CFG = Object.assign({
    propertyName: '⚠️ Freight',
    valueVanity: 'Quoted separately – not included at checkout',
    valueWeight: 'Quoted separately – not included at checkout',   // same wording for every quoted item
    matchText: 'Quoted separately',          // used to find the note on screen
    legacyNames: ['Freight'],                // earlier wording; removed from lines automatically
    alwaysQuoteTypes: ['Vanities'],
    tableTypes: ['Tiles', 'Basins', 'Toilets', 'Timber Flooring'],
    tableMaxKg: 3000
  }, window.DT_FREIGHT_TBA || {});

  var cart = null;
  var syncing = false;
  var pending = false;

  function lower(a) { return a.map(function (s) { return String(s).toLowerCase(); }); }
  var ALWAYS = lower(CFG.alwaysQuoteTypes);
  var TABLE = lower(CFG.tableTypes);
  function typeOf(item) { return String(item.product_type || '').toLowerCase(); }

  // Which lines need the note, and which wording.
  function analyse(c) {
    var tableKg = 0;
    c.items.forEach(function (it) {
      if (TABLE.indexOf(typeOf(it)) !== -1) tableKg += (Number(it.grams) || 0) * it.quantity / 1000;
    });
    var overWeight = tableKg > CFG.tableMaxKg;
    var lines = c.items.map(function (it) {
      var t = typeOf(it);
      var value = ALWAYS.indexOf(t) !== -1 ? CFG.valueVanity : (overWeight && TABLE.indexOf(t) !== -1 ? CFG.valueWeight : null);
      return { item: it, value: value };
    });
    return { lines: lines, tbaLines: lines.filter(function (l) { return l.value; }) };
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Add, update or remove the note on each line so it matches the rules.
  function sync() {
    if (syncing) { pending = true; return Promise.resolve(); }
    syncing = true;
    return getCart().then(function (c) {
      var changes = analyse(c).lines.filter(function (l) {
        var props = l.item.properties || {};
        var legacy = (CFG.legacyNames || []).some(function (n) { return n in props; });
        return legacy || (l.value ? props[CFG.propertyName] !== l.value : CFG.propertyName in props);
      });
      var chain = Promise.resolve();
      changes.forEach(function (l) {
        chain = chain.then(function () {
          var props = Object.assign({}, l.item.properties || {});
          (CFG.legacyNames || []).forEach(function (n) { delete props[n]; });
          if (l.value) props[CFG.propertyName] = l.value; else delete props[CFG.propertyName];
          return fetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: l.item.key, quantity: l.item.quantity, properties: props })
          });
        });
      });
      return chain.then(function () {
        if (!changes.length) return c;
        return getCart().then(function (c2) { refreshThemeCart(c2); return c2; });
      });
    }).then(function (c) {
      cart = c;
      renderNotices();
    }).catch(function (e) {
      if (window.console) console.warn('[dt-freight-tba]', e);
    }).then(function () {
      syncing = false;
      if (pending) { pending = false; sync(); }
    });
  }

  // Ask the Impact theme to re-render its cart after we change notes.
  function refreshThemeCart(c) {
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: c } })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: c } })); } catch (e) {}
    if (location.pathname.replace(/\/$/, '') === '/cart' && !document.querySelector('cart-drawer[open]')) {
      // The cart page renders server-side; reload once so the notes show on each line.
      if (!sessionStorage.getItem('dtFreightTbaReloaded')) {
        sessionStorage.setItem('dtFreightTbaReloaded', '1');
        location.reload();
        return;
      }
    }
    sessionStorage.removeItem('dtFreightTbaReloaded');
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }

  // Shared wording for the cart box and the pop-up.
  function messageHtml(a, titleClass) {
    return '<p class="' + titleClass + '">⚠️ Shipping not included for these items</p>' +
      '<ul class="dt-tba__list">' + a.tbaLines.map(function (l) {
        return '<li>' + esc(l.item.product_title) + (l.item.quantity > 1 ? ' × ' + l.item.quantity : '') + '</li>';
      }).join('') + '</ul>' +
      '<p class="dt-tba__text">We’ll be in touch with your freight quote within 24 hrs.</p>' +
      '<p class="dt-tba__other">Shipping for other items is calculated at checkout.</p>';
  }

  // Keep the heading and the two sentences on one line each: shrink the text just enough
  // to fit the box (phones), never below 9px; if it still can't fit, let it wrap.
  var FIT = '.dt-tba__title, .dt-tba-modal__title, .dt-tba__text, .dt-tba__other';
  function fitLines(root) {
    if (!root || !root.clientWidth) return;   // hidden (e.g. drawer closed): fit when shown
    Array.prototype.forEach.call(root.querySelectorAll(FIT), function (el) {
      el.style.fontSize = '';
      el.style.whiteSpace = 'nowrap';
      var size = parseFloat(getComputedStyle(el).fontSize) || 12;
      while (el.scrollWidth > el.clientWidth + 1 && size > 9) {
        size -= 0.25;
        el.style.fontSize = size + 'px';
      }
      if (el.scrollWidth > el.clientWidth + 1) el.style.whiteSpace = '';
    });
    // The two sentences share one size so they read as a pair.
    var pair = root.querySelectorAll('.dt-tba__text, .dt-tba__other');
    if (pair.length === 2 && (pair[0].style.fontSize || pair[1].style.fontSize)) {
      var s = Math.min(parseFloat(getComputedStyle(pair[0]).fontSize), parseFloat(getComputedStyle(pair[1]).fontSize));
      pair[0].style.fontSize = pair[1].style.fontSize = s + 'px';
    }
  }
  function fitAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.dt-tba, .dt-tba-modal[open]'), fitLines);
  }
  window.addEventListener('resize', function () { clearTimeout(window.__dtFit); window.__dtFit = setTimeout(fitAll, 150); });

  // Make the note on each cart line red and bold (drawer + cart page).
  function highlightLineNotes() {
    Array.prototype.forEach.call(document.querySelectorAll('main, cart-drawer'), function (root) {
      Array.prototype.forEach.call(root.querySelectorAll('li, p, span, div, dd, dt'), function (el) {
        if (el.closest('.dt-tba, .dt-tba-modal, .dt-tba-line')) return;
        if ((el.textContent || '').indexOf(CFG.matchText) === -1) return;
        // Only the innermost element holding the note (never the whole product line)...
        var inner = Array.prototype.some.call(el.children, function (ch) { return (ch.textContent || '').indexOf(CFG.matchText) !== -1; });
        if (inner) return;
        // ...widened to its list item when that item is just the note.
        var li = el.closest('li');
        (li && (li.textContent || '').trim().length < 160 ? li : el).classList.add('dt-tba-line');
      });
    });
  }

  // Notice above every cart form that has a Checkout button (drawer and cart page).
  function renderNotices() {
    highlightLineNotes();
    var a = cart ? analyse(cart) : null;
    Array.prototype.forEach.call(document.querySelectorAll('form[action*="/cart"]'), function (f) {
      if (!f.querySelector('[name="checkout"]')) return;
      var box = f.previousElementSibling && f.previousElementSibling.classList.contains('dt-tba') ? f.previousElementSibling : null;
      if (!a || !a.tbaLines.length) { if (box) box.remove(); return; }
      var html = messageHtml(a, 'dt-tba__title');
      if (!box) { box = document.createElement('div'); box.className = 'dt-tba'; f.parentNode.insertBefore(box, f); }
      // Compare with what we last wrote (the browser re-serialises innerHTML, so comparing it would loop).
      if (box.getAttribute('data-dt-html') !== html) { box.innerHTML = html; box.setAttribute('data-dt-html', html); }
      fitLines(box);
    });
  }

  // Pop-up every time Checkout is clicked while the cart has quoted items.
  var passThrough = false;
  function openModal(onContinue) {
    var a = analyse(cart);
    var d = document.getElementById('dt-tba-modal');
    if (!d) {
      d = document.createElement('dialog');
      d.id = 'dt-tba-modal';
      d.className = 'dt-tba-modal';
      document.body.appendChild(d);
    }
    d.innerHTML = '<div class="dt-tba-modal__inner">' + messageHtml(a, 'dt-tba-modal__title') +
      '<div class="dt-tba-modal__buttons">' +
      '<button type="button" class="button button--secondary" data-dt-back>Back to cart</button>' +
      '<button type="button" class="button" data-dt-continue>Continue to checkout</button>' +
      '</div></div>';
    d.querySelector('[data-dt-back]').onclick = function () { d.close(); };
    d.querySelector('[data-dt-continue]').onclick = function () { d.close(); onContinue(); };
    if (typeof d.showModal === 'function') { d.showModal(); fitLines(d.querySelector('.dt-tba-modal__inner')); }
    else if (confirm(d.innerText)) onContinue();
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!el || passThrough || !cart || !analyse(cart).tbaLines.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openModal(function () {
      passThrough = true;
      el.click();
      setTimeout(function () { passThrough = false; }, 1500);
    });
  }, true);

  // Re-check whenever the cart changes (theme events + any /cart/* request).
  var t;
  function soon() { clearTimeout(t); t = setTimeout(sync, 300); }
  ['cart:change', 'cart:refresh', 'variant:add'].forEach(function (ev) {
    document.addEventListener(ev, function () { if (!syncing) soon(); });
  });
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (!syncing && /\/cart\/(add|change|update|clear)/.test(url)) p.then(soon, soon);
    return p;
  };
  // Drawer and cart page re-render their markup; put the notice back each time.
  var mo;
  new MutationObserver(function () { clearTimeout(mo); mo = setTimeout(renderNotices, 100); })
    .observe(document.documentElement, { childList: true, subtree: true });
  // When the drawer opens, re-fit the notice text to its width.
  new MutationObserver(function () { setTimeout(fitAll, 350); })
    .observe(document.documentElement, { attributes: true, attributeFilter: ['open'], subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
